import { Component, Input } from '@angular/core';
import { BroadcastThreadViewModel } from '../../api/models';
import { NgIf, PercentPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { HighlightPipe } from '../../core/pipes/highlight.pipe';
import { HumanizedDatePipe } from '../../core/pipes/humanized-date.pipe';

@Component({
    selector: 'app-broadcast-phone-number-group-item',
    template: `
    <div class="item-container" *ngIf="!dataItem">
      <div class="item-avatar">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
      <div class="item-content">
        <div class="item-header">
          <h4 class="item-heading">Loading...</h4>
        </div>
      </div>
    </div>
    <div class="item-container" *ngIf="!!dataItem">
      <div class="item-content">
        <div class="item-header">
          <h4 class="item-heading">
            <span class="item-contact">
              {{ dataItem?.name }}
            </span>
            <span class="item-summary">{{ dataItem.received / dataItem.total || 0.001 | percent }} delivered</span>
          </h4>
          <div class="right-holder">
            <time class="item-time" *ngIf="dataItem.lastTime">
              {{ dataItem.lastTime | humanizedDate }}
            </time>
            <time class="item-time" *ngIf="!dataItem.lastTime"> never </time>
          </div>
        </div>
        <div class="item-last-message">
          <p [innerHTML]="dataItem.lastMessage | highlight: searchText"></p>
        </div>
      </div>
    </div>
  `,
    styleUrls: ['./broadcast-phone-number-group-item.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        MatProgressSpinner,
        PercentPipe,
        HighlightPipe,
        HumanizedDatePipe,
    ],
})
export class BroadcastPhoneNumberGroupItemComponent {
  @Input() dataItem: BroadcastThreadViewModel;
  @Input() searchText: string;
}
